module.exports = __webpack_public_path__ + "static/media/badge_highfive_2.b1edd70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_highfive_2.png
// module id = 499
// module chunks = 0